<script lang="ts">
  // https://www.fullstacklabs.co/blog/creating-an-svg-gauge-component-from-scratch
  import Stars from './Stars.svelte';
  import Marquee from '../Marquee.svelte';
  import { dims } from '~/utils/dimensions.svelte';
  import GaugeContainer from '../GaugeContainer.svelte';
  import { Tween } from 'svelte/motion';
  import { starInAnimation, type Direction } from '~/animations.svelte';
  import { delay } from '~/animations/utils.svelte';
  import { sendWordAnimation } from '~/animations/crossfade.svelte';
  import { getGame } from '~/store/GameContext.svelte';
  import type { ClassicGame } from '~/store/classic.svelte';

  const game = $derived(getGame<ClassicGame>().current);

  const [radius, strokeWidth, starSize] = $derived(dims.gauge);
  const innerRadius = $derived(radius - strokeWidth / 2);

  const flooredSwaps = $derived(Math.max(game.swaps, 0));
  const tweenedSwaps = new Tween(flooredSwaps);
  let prevSwaps = $state(flooredSwaps);
  let difference = $state(0);
  let direction = $state<Direction>();

  $effect(() => {
    if (prevSwaps < flooredSwaps) {
      delay(75)
        .then(() =>
          Promise.all([sendWordAnimation.settled(), starInAnimation.settled()]),
        )
        .then(() => {
          difference = Math.abs(prevSwaps - flooredSwaps);
          prevSwaps = flooredSwaps;
          tweenedSwaps.set(flooredSwaps, { duration: difference * 250 });
          direction = 'down';
        });
    } else if (prevSwaps > flooredSwaps) {
      difference = Math.abs(prevSwaps - flooredSwaps);
      prevSwaps = flooredSwaps;
      tweenedSwaps.set(flooredSwaps, { duration: difference * 250 });
      direction = 'up';
    } else if (prevSwaps !== flooredSwaps) {
      prevSwaps = flooredSwaps;
      tweenedSwaps.set(flooredSwaps);
    }
  });

  const newSwaps = $derived(Math.floor(tweenedSwaps.current));
</script>

<GaugeContainer {radius} {direction} swaps={newSwaps} marquee={game.marquee}>
  {#snippet svg()}
    <Marquee {radius} {innerRadius} marquee={game.marquee} />
  {/snippet}
  {#snippet stars()}
    <Stars {radius} {starSize} stars={newSwaps} />
  {/snippet}
</GaugeContainer>
